export enum Type {
	positive, negative
}
